import { requestHttp } from "../utils/HttpRequest";

export const getVisitsMetrics = (idUser, date) => {
  try {
    const response = requestHttp({
      endpoint: "visit_metrics",
      data: {
        user_id: idUser,
        chosen_date: date,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
